<template>
    <div ref="root" class="productImageRoot" :style="{height : imgHeight + 'px'}" :class="sizeClass" @mouseover="mouseOver=true" @mouseout="mouseOver=false">
        <img v-if="image" v-lazy="image" class="img-fluid" itemprop="image" :alt="alt" />
        <img v-if="tilbud" src="/Dist/img/sticker-tilbud.png" class="sticker" />
        <img v-if="spar"   src="/Dist/img/sticker-spar.png"   class="sticker" />
        <div class="labels">
        </div>
    </div>
</template>

<script>
// import { mapGetters } from 'vuex';
import { GetOptimalImageFormat } from "../services/Modenizr";
import imageService from "../services/imageService.vue"
const sizes = [900, 800, 432, 255, 204]; //[204, 255, 432, 800];

export default {
    props:["no", "file", "spar", "tilbud", "labelEuBlomsten", "labelFoedevare", "labelIndeklima", "labelSvane", "mouseOverToggle", "alt"],
    watch:{
        file()
        {
            this.setImage();
        },
        mouseOver(){
            this.setImage();
        },
        no(){
            this.setImage();
        }
    },
    computed:{
        styles(){
            return{
                height:this.imgHeight + "px",
                width:this.imgHeight + "px"
            }
        }
    },
    methods:{
        setImage(){
            // this.image = "";
            this.$nextTick(async ()=>{
                var offsetWidth = this.$refs.root.offsetWidth + 1;
                this.imgHeight = offsetWidth;
                // console.log(offsetWidth);
                var size = sizes[0];
                sizes.forEach(s=>{
                    if(offsetWidth<=s)
                        size = s;
                });
                // console.log("find image for :" + this.no);
                var no = this.no;
                if(no.indexOf("rk")==0)
                    no = no.substr(2);
                    // console.log("no:"+no);
                var images = await imageService.getImages(no);
                if(!images || images.length == 0)
                {
                    this.image = '/Dist/img/foto-mangler.png'
                }
                else
                {
                    GetOptimalImageFormat().then((format)=>{
                        // if(this.file)
                        //     this.image = `https://rknew.azureedge.net/rknew/${this.no}/${size}/${this.file}.${format}`; 
                        // else
                        //     this.image = `https://rknew.azureedge.net/rknew/${this.no}/${size}/${images[0]}.${format}`; 
                        if(this.file)
                            this.image = `/ProductImages/${no}/${size}/${no}_${this.file}.${format}`; 
                        else if(this.mouseOverToggle && this.mouseOver && images.length>1)
                            this.image = `/ProductImages/${no}/${size}/${no}_${images[1]}.${format}`; 
                        else
                            this.image = `/ProductImages/${no}/${size}/${no}_${images[0]}.${format}`; 
                    });
                }
                this.sizeClass = offsetWidth < 80 ? "tiny":
                    offsetWidth < 100 ? "small":
                    offsetWidth < 132 ? "medium":"";
            });
        }
    },
    data(){
        return {
            mouseOver:false,
            image : null,
            sizeClass : "",
            imgHeight : null
        }
    },
    mounted()
    {
        this.setImage();
        setTimeout(this.setImage, 100);
        window.addEventListener('resize', this.setImage)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setImage)
    }
}
</script>
<style lang="scss" scoped>
    .productImageRoot
    {
        position: relative;
        text-align: center;
    }
    .sticker{
        position: absolute;
        top: 2%;
        left: 2%;
        width: auto;
        .tiny &{
            width: 40%;
            line-height: 40px;
            font-size:0.75rem;
        }
        .small &{
            width: 50%;
            line-height: 50px;
            font-size:0.85rem;
        }
    }
    .labels{
        width:30px;
        position:absolute;
        bottom:2%;
        right:2%;
        .small &{
            display:none;
        }
        .medium &{
            img{
                width: 28px;
            }
        }
    }

    img[lazy='loaded'] {
        opacity: 0;
        animation-name: fadein;
        animation-duration: .5s;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
        animation-direction: normal;
        animation-timing-function: ease-out;
        @keyframes fadein {
            0% {
            opacity: 0;
            }
            100% {
            opacity: 1;
            }
        }
    }
</style>
